const PopupBase = ({ children, close, confirm, title, confirmText, cancelText }) => {
    return (
        <div className="modal-dialog" style={{ opacity: 1, display: 'flex', transition: 'opacity 300ms' }}>
            <div className="dim" style={{ opacity: 1, display: 'flex', transition: 'opacity 300ms' }}></div>
            <div className="modal-content" id="modal01" style={{ opacity: 1, display: 'flex', transition: 'opacity 300ms' }}>
                <div className="modal-alert" noValidate="" id="modalForm">
                    <div className="modal-head">
                        <div className="modal-title">
                            <h1>{title}</h1>
                        </div>
                        <button type="button" className="modal-button-cancel" onClick={close}>
                            <i className="icon icon-close"></i>
                        </button>
                    </div>
                    <div className="modal-body">
                        {children}
                    </div>
                    <div className="modal-controls">
                        <button type="button" className="modal-button modal-button-cancel" onClick={close}>{cancelText}</button>
                        <button type="button" className="modal-button modal-button-submit" onClick={confirm}>{confirmText}</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PopupBase;